import { ReactElement } from 'react';
import { PaymentState as PaymentStateType } from 'modules/invoicing/common/types';
import { IconBadge, IconBadgeBaseProps } from 'components/IconBadge/IconBadge';

interface PaymentStateProps {
  state: PaymentStateType | null;
}

const STATE_MAP: Record<PaymentStateType, IconBadgeBaseProps> = {
  PENDING: {
    title: 'Payment pending',
    icon: 'timer',
    background: 'gray100',
    color: 'gray700',
  },
  PARTIAL: {
    title: 'Partial payment',
    icon: 'coins',
    background: 'warning600',
    color: 'white',
  },
  PAID: {
    title: 'Paid',
    icon: 'coins',
    background: 'gray100',
    color: 'success600',
  },
  LATE: {
    title: 'Late',
    icon: 'timer',
    background: 'error500',
    color: 'white',
  },
};

export function PaymentStateBadge({ state }: PaymentStateProps): ReactElement {
  const props = state ? STATE_MAP[state] : { icon: null };
  return <IconBadge {...props} />;
}
